import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { StorySection } from '../components/StorySection';
import { QualifierSection } from '../components/QualifierSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function SalesPage() {
  return <main className="min-h-screen bg-night-950 text-slate-200 selection:bg-gold-500/30 selection:text-white" data-id="element-194">
      <HeroSection data-id="element-195" />
      <ProblemSection data-id="element-196" />
      <SolutionSection data-id="element-197" />
      <StorySection data-id="element-198" />
      <QualifierSection data-id="element-199" />
      <TestimonialSection data-id="element-200" />
      <PricingSection data-id="element-201" />
      <FAQSection data-id="element-202" />

      <footer className="py-8 text-center text-slate-600 text-sm border-t border-white/5 bg-night-950" data-id="element-203">
        <p data-id="element-204">
          © {new Date().getFullYear()} The Taproot Protocol. All rights
          reserved.
        </p>
        <div className="mt-2 space-x-4" data-id="element-205">
          <a href="#" className="hover:text-slate-400 transition-colors" data-id="element-206">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-slate-400 transition-colors" data-id="element-207">
            Terms of Service
          </a>
          <a href="#" className="hover:text-slate-400 transition-colors" data-id="element-208">
            Contact
          </a>
        </div>
      </footer>

      <PurchaseNotification data-id="element-209" />
    </main>;
}